// GENERATED from bosses.store by tools/boss-store.js — do not edit.
export const BOSSES_DATA = [
  {
    "id": 1,
    "name": "Luminak",
    "family": "dragon",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "stats": {
      "atkMin": 1,
      "atkMax": 50,
      "speedTicks": 150,
      "attack": 80,
      "meleeDef": 50,
      "magicDef": 200,
      "range": 50,
      "moveSpeedTicks": 35,
      "maxHp": 450
    },
    "mechanic": {
      "kind": "none"
    }
  },
  {
    "id": 2,
    "name": "Bu11seye00",
    "family": "bull",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": 2,
    "stats": {
      "maxHp": 300,
      "atkMin": 1,
      "atkMax": 90,
      "speedTicks": 50,
      "attack": 75,
      "meleeDef": 90,
      "magicDef": 90,
      "range": 1,
      "moveSpeedTicks": 10
    },
    "mechanic": {
      "kind": "none"
    }
  },
  {
    "id": 3,
    "name": "Ice giant",
    "family": "ice-giant",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "stats": {
      "maxHp": 300,
      "atkMin": 1,
      "atkMax": 60,
      "speedTicks": 60,
      "attack": 50,
      "meleeDef": 50,
      "magicDef": 25,
      "range": 1,
      "moveSpeedTicks": 20
    },
    "mechanic": {
      "kind": "heavy-freeze",
      "chanceNumerator": 1,
      "chanceDenominator": 3,
      "attackDurationPct": 200,
      "damagePct": 200,
      "freezeTicks": 200
    }
  },
  {
    "id": 4,
    "name": "Ice hound",
    "family": "ice-hound",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "stats": {
      "maxHp": 200,
      "atkMin": 1,
      "atkMax": 30,
      "speedTicks": 40,
      "attack": 30,
      "meleeDef": 30,
      "magicDef": 30,
      "range": 1,
      "moveSpeedTicks": 10
    },
    "mechanic": {
      "kind": "pounce",
      "bitesBeforeLeap": 5,
      "windupTicks": 20,
      "flightTicks": 10,
      "recoveryTicks": 12,
      "leapRange": 5,
      "impactRadius": 1,
      "damagePct": 300
    }
  },
  {
    "id": 5,
    "name": "Frost Sorceress",
    "family": "frost-sorceress",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "spellColor": "#76dcff",
    "spellRadius": 12,
    "stats": {
      "maxHp": 180,
      "atkMin": 1,
      "atkMax": 20,
      "speedTicks": 40,
      "attack": 100,
      "meleeDef": 15,
      "magicDef": 200,
      "range": 12,
      "moveSpeedTicks": 10
    },
    "mechanic": {
      "kind": "freeze-blink",
      "averageIntervalTicks": 250,
      "windupTicks": 10,
      "freezeTicks": 150,
      "minDistance": 3,
      "tauntTicks": 80
    },
    "taunts": [
      "Nice try.",
      "You'll never catch me!",
      "Too slow."
    ]
  },
  {
    "id": 6,
    "name": "Hell hound",
    "family": "hell-hound",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "stats": {
      "maxHp": 250,
      "atkMin": 1,
      "atkMax": 30,
      "speedTicks": 40,
      "attack": 50,
      "meleeDef": 50,
      "magicDef": 50,
      "range": 1,
      "moveSpeedTicks": 10
    },
    "mechanic": {
      "kind": "fire-pounce",
      "bitesBeforeLeap": 5,
      "windupTicks": 20,
      "flightTicks": 10,
      "recoveryTicks": 12,
      "leapRange": 5,
      "impactRadius": 1,
      "damagePct": 300,
      "fireTicks": 80,
      "fireIntervalTicks": 20,
      "fireDamagePct": 25
    }
  },
  {
    "id": 7,
    "name": "Red demon",
    "family": "red-demon",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "movable": false,
    "lootTable": 2,
    "stats": {
      "maxHp": 330,
      "atkMin": 1,
      "atkMax": 35,
      "speedTicks": 40,
      "attack": 60,
      "meleeDef": 60,
      "magicDef": 35,
      "range": 1,
      "moveSpeedTicks": 10
    },
    "mechanic": {
      "kind": "meteor-shower",
      "intervalTicks": 160,
      "meteorCount": 8,
      "windupTicks": 30,
      "recoveryTicks": 12,
      "damagePct": 200
    }
  },
  {
    "id": 8,
    "name": "Orb wizard",
    "family": "wizard",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "movable": false,
    "lootTable": null,
    "spellColor": "#c594ff",
    "spellRadius": 10,
    "stats": {
      "maxHp": 500,
      "atkMax": 12,
      "speedTicks": 50,
      "attack": 60,
      "meleeDef": 70,
      "magicDef": 70,
      "range": 12,
      "moveSpeedTicks": 20
    },
    "mechanic": {
      "kind": "orb-burst",
      "minOrbs": 3,
      "maxOrbs": 5,
      "countdownTicks": 60,
      "baseWindowTicks": 10,
      "perOrbTicks": 8,
      "firstDamagePct": 5,
      "secondDamagePct": 10,
      "thirdDamagePct": 25,
      "fourthDamagePct": 40
    }
  }
] as const;
